
	import {
		Component,
		Vue,
		Inject,
		Prop,
		Watch,
	} from 'vue-property-decorator';
	import Util from '@/lib/util';
	import AbpBase from '@/lib/abpbase';
	import Viewer from 'v-viewer'
	import 'viewerjs/dist/viewer.css'
	import liburl from '@/lib/url';
	import DropDownRefresh from '@/components/DropDownRefresh.vue'

	import PullRefresh from '@/components/PullRefresh.vue'
	import AudioEnter from '@/components/AudioEnter2.vue'
	import axios from 'axios'
	import ajax from '@/lib/ajax'
	import {
		Base64
	} from 'js-base64';
	import moment from 'moment'
	import VueMarkdown from 'vue-markdown'
	import he from 'he';
	@Component({
		components: {
			VueMarkdown,
			DropDownRefresh,
			PullRefresh,
			AudioEnter
		}
	})


	export default class SessionAI extends AbpBase {
		config: {
			// 禁用页面滑动
			disableScroll: true
		}
		userAgent: string = "";
		// sessinfo: Object = new Object() as any;
		sessinfo: Object = {
			id: 0
		}
		sid: number = 0;

		userid: number = 0;
		commentBox: boolean = false;
		isRefresh: boolean = true;
		historyList: Array < Object > = new Array < Object > ();
		historyNew: Array < Object > = new Array < Object > ();
		commentContent: string = "";
		loadmore: boolean = true;
		optertionInfo: Object = {
			likeId: 0,
			isLike: false,
			followId: 0,
			isFollow: false
		};
		userInfo: Object = new Object();
		anonymous: boolean = false;
		imgBox: boolean = false;
		currentImgs: Array < Object > = new Array < Object > ();
		currentImgUrl: string = '';
		screenWidth: number = 0;
		appList: Array < Object > = new Array < Object > ();
		appid: number = 0;
		showmenu: boolean = false;
		disabled: boolean = false;
		showHistory: boolean = false;
		isFresh: boolean = false;
		isSend: boolean = false;
		showTool: boolean = false;
		scrollHeight: number = 500;
		scrollid: string = "";
		prompt: string = "";
		imgurl: string = '';
		loadingType: number = 0;
		pagesize: number = 10;
		pageindex: number = 1;
		sessionid: string = "";
		sessionCount: number = 0;

		actiontype: number = 0; //1 赞 2 踩
		ispc: boolean = false;

		ansterdata: string = "";
		answerstop: boolean = true;
		showstop: boolean = false;

		keyboardvic: number = 0;
		isShow: boolean = false;
		random: number = 0;
		showpage: string = "2";

		srcollHeight: number = 137;
		//passuserid:Array<Object> = [10000,1600,1601,40376,40375,40374,40373,40372,40371,40370,40369,40368,40367];




		showShare: boolean = false;
		shownews: number = 0; // 0加载中 1 可见 2 不可见
		msg: string = '';
		isPreview: boolean = false;
		newsReadCount: number = 0;
		top: 0;
		startY: number = 0;
		moveY: number = 0;
		isRefreshing: false;
		title: string = "";
		audioTitle: string = "";
		sendTitle: string = "";

		pcAudioTitle: string = "";
		pcSendTitle: string = "";

		dateToday: string = "";
		weekToday: string = "";
		noonTip: string = "";

		lastTitle: string = "";
		isios: boolean = false;

		currentIndex: number = 5
		transition: number = 300;
		//定时器
		transTimer: number = null;
		scrollData: Array < string > = ['1', '2', '3', '4', '5', '6', '7', '8']
		tabTitle: string = "chat";
		tagList: Array < any > = new Array < any > ();
		lang: string = "";
		showai: boolean = true;
		showzhushou: boolean = false;


		showDownloadImgPopup: boolean = false;

		downLoadImgUrl: string = ""


		pressTimer = null;

		goFeekBck() {
			console.log(1)
			uni.postMessage({
				data: {
					action: 'message'
				}
			});
		}
		getSafeAreaInsetTop() {
			try {
				const style = getComputedStyle(document.documentElement);
				const safeAreaInsetTop = style.getPropertyValue('--safe-area-inset-top').trim();
				console.log('Safe area inset top:', safeAreaInsetTop);
			} catch (e) {
				//TODO handle the exception
			}

			// 你可以根据需要将值存储在组件的数据属性中
		}

		changeTab(tabtype) {
			var that = this;
			if (tabtype == 'assistant') {
				if (this.appList.length > 1) {
					this.appid = (this.appList[1] as any).id;
				}
			}
			if (tabtype == 'chat') {
				if (this.appList.length > 0) {
					this.appid = (this.appList[0] as any).id;
				}
			}
			this.tabTitle = tabtype;
			that.historyList = [];
			that.loadingType = 0;
			that.scrollid = "";
			that.pageindex = 1;
			that.sessionid = "";
			that.historyNew = [];
			that.lastTitle = "";
			that.showpage = '2';
			that.getSessionNew();
			var info = {
				id: 0,
				prompt: "",
				answer: '',
				isload: false,
			}
			that.sessinfo = info;

		}
		getTipsList() {
			var that = this;
			var request = new Object() as any;
			request.maxResultCount = 1000;
			request.skipCount = 0;
			request.type = 12;

			this.$store.dispatch({
				type: 'tag/getAllList',
				data: request
			}).then(res => {
				console.log(res);
				var result = res.items;
				that.tagList = result;
				console.log(result)

			})


		}

		//状态栏高度
		get statusBarHeight() {
			var height = 0;
			var isios = this.isIos();
			if (isios) {
				try {
					const style = getComputedStyle(document.documentElement);
					const safeAreaInsetTop = style.getPropertyValue('--safe-area-inset-top').trim().replace('px', '')
						.replace('pt', '');
					if (safeAreaInsetTop != '') {
						height = parseInt(safeAreaInsetTop)
					} else {
						height = 44;
					}
					console.log("safeAreaInsetTop:" + safeAreaInsetTop);
				} catch (e) {
					height = 44;
				}
			} else {
				height = window.innerHeight * 0.05;
			}
			this.srcollHeight = (137 + height);
			var heightnew = height + 'px';
			return heightnew;
		}

		// 滚动样式
		get transStyle() {
			return {
				transition: `${this.transition}ms`,
				transform: `translate3d(0,${this.currentIndex * -40}px, 0)`
			}
		}
		voiceChange() {
			if (!this.disabled) {
				this.prompt = "";
				this.keyboardvic = this.keyboardvic == 0 ? 1 : 0;
			}
		}
		cancelAudio() {
			this.prompt = "";
		}
		async closeAudio(data, touchEndTrans) {
			//console.log(touchEndTrans)
			var that = this;
			if (!that.disabled && data.size > 100) {
				var form = new FormData();
				form.append("upfile", data);
				var res = await this.$store.dispatch({
					type: 'app/speechProcess',
					data: form
				}).then((res) => {
					if (res.success) {

						that.prompt = res.msg;
						that.random = Math.floor(Math.random() * 100 + 1);

						if (!touchEndTrans) {
							that.sessionSave();
						}
					} else {
						that.$Message.warning("解析失败")
					}

				})
			}

		}
		async sendAudio(content) {
			this.prompt = content;
			//console.log(this.prompt)
			this.keyboardvic = 0;
			this.sessionSave();
		}

		//上拉 开启新话题
		onRefreshUp(done) {
			var that = this;
			console.log("onRefreshUp")
			return;

			if (that.userid > 0) {
				if (that.showpage == '2') {
					that.historyList = [];
					that.loadingType = 0;
					that.scrollid = "";
					that.pageindex = 1;
					that.sessionid = "";
					that.historyNew = [];
					that.getSessionNew();
					var info = {
						id: 0,
						prompt: "",
						answer: '',
						isload: false,
					}
					that.sessinfo = info;

					try {
						done();
					} catch (e) {
						//TODO handle the exception
					}

					return
				}
				that.showpage = '2';
				that.historyList = [];
				that.loadingType = 0;
				that.scrollid = "";
				that.pageindex = 1;
				that.sessionid = "";
				try {
					if (that.isios) {
						window.webkit.messageHandlers.vibrate.postMessage(100);
					} else {
						navigator.vibrate(100);
					}
				} catch (e) {
					//TODO handle the exception
				}
				that.historyNew = [];
				that.getSessionNew();
				var info = {
					id: 0,
					prompt: "",
					answer: '',
					isload: false,
				}
				that.sessinfo = info;

				that.$nextTick(() => {
					//添加出现动画
					//document.getElementsByClassName('page2-content')[0].classList.add('page2-content-animation');
				})
				try {
					done();
				} catch (e) {
					//TODO handle the exception
				}

			}
		}

		//下拉 查理历史
		onRefresh(done) {
			var that = this;
			console.log("onRefresh")
			that.showpage = '1';
			if (that.userid > 0) {
				// 如果下拉刷新和上拉加载同时使用，下拉时初始化上拉的数据
				console.log("done")
				if (that.loadingType != 0) { //loadingType!=0;直接返回

					that.isFresh = true;
					setTimeout(function() {

						that.isFresh = false;
						console.log(that.isFresh)
					}, 100)
					try {
						done();
					} catch (e) {
						//TODO handle the exception
					}

					return false;
				}
				that.isFresh = true;
				if (that.pageindex == 1) {
					try {
						if (that.isios) {
							window.webkit.messageHandlers.vibrate.postMessage(100);
						} else {
							navigator.vibrate(100);
						}

					} catch (e) {
						//TODO handle the exception
					}
				}


				this.load();
				that.showHistory = true;
				setTimeout(function() {

					that.isFresh = false;
					console.log(that.isFresh)

				}, 800)
			}
			try {
				done();
			} catch (e) {
				//TODO handle the exception
			}


		}
		/**
		 * 上拉加载
		 */
		onInfiniteLoad(done) {
			// console.log("load")
			done()
		}
		share() {
			this.showShare = true;

		}
		shareToWeixin(shareWeixinType) {
			var that = this;
			var sessinfo = (this.sessinfo as any);
			var title = sessinfo.prompt;
			var link = location.protocol + "//" + location.host + "/#/sessionai?sid=" + sessinfo.id;
			var content = "点击查看完整对话";
			title = title.substr(0, 20);
			//var coverImg = sessinfo.coverImg;
			if (content == '') {
				content = title;
			}
			// if (that.isIos()) {
			// 	that.$store.dispatch({
			// 		type: 'app/refreshOSSPresignedUri',
			// 		data: {
			// 			url: coverImg,
			// 			process: 'image/resize,m_fixed,w_30,h_30'
			// 		}
			// 	}).then(res => {
			// 		coverImg = res;
			// 		that.gisShareToWeixin(title, content, link, coverImg, shareWeixinType);
			// 	});
			// } else {
			that.gisShareToWeixin(title, content, link, "", shareWeixinType);
			//}

		}
		gisShareToWeixin(title, content, link, coverImg, shareWeixinType) {
			var that = this;
			// shareWeixinType: string = "WXSceneSession" // WXSceneTimeline
			(window as any).gis.shareToWeixin({
				type: 'web',
				title: title,
				content: content,
				href: link,
				thumbs: [""],
				extra: {
					scene: shareWeixinType
				},
				// pictures:[news.coverImg],
				success: function() {
					//that.showShare = false;
					//that.createNewsOperation(3);
				},
				fail: function() {
					that.showShare = false;
				}
			})
		}

		inputChange(e) {
			// if (e.target.value.length > 0) {
			// 	this.isSend = true;
			// } else {
			// 	this.isSend = false;
			// }
		}
		isIos() {
			var u = navigator.userAgent.toLowerCase();
			this.userAgent = u;
			if (u.indexOf("iphone") > -1 || u.indexOf("ios") > -1 || u.indexOf("mac") > -1) {
				return true;
			}
			return false;
		}
		load() {
			var that = this;
			that.loadSessionHistoryList();
		}
		minutesDifference(time1, time2) {
			// 将时间字符串转换为日期对象
			var date1 = new Date(time1);
			var date2 = new Date(time2);

			// 计算两个日期之间的毫秒差值
			var diff = date2.getTime() - date1.getTime();

			// 将毫秒差值转换为分钟
			return diff / (1000 * 60);
		}
		loadSessionHistoryList() {
			var that = this;

			that.loadingType = 1;

			var request = new Object() as any;
			request.maxResultCount = this.pagesize;
			request.skipCount = (this.pageindex - 1) * this.pagesize;
			request.appId = that.appid
			this.$store.dispatch({
				type: 'app/getSessionHistoryList',
				data: request
			}).then((res) => {
				var list = res.items;
				if (list.length < that.pagesize) {
					that.loadingType = 2;
					that.title = that.L("已无更多历史对话");
				} else {
					that.loadingType = 0; //将loadingType归0重置
					that.pageindex++;
				}
				var scrollid = "";
				for (var i = 0; i < list.length; i++) {
					var findindex = that.historyNew.findIndex(e => {
						return (e as any).id == list[i].id
					})
					if (findindex < 0) {
						list[i].isload = false;
						list[i].showdate = true;
						list[i].datetime = that.formatDateStr(list[i].creationTime);
						if (i < list.length - 1) {
							var date1 = list[i].creationTime;
							var date2 = list[i + 1].creationTime;
							var mins = that.minutesDifference(date2, date1);
							//console.log("date1:"+date2+",date2:"+date1+",mins:"+mins)
							if (mins < 5) {
								list[i].showdate = false;
							}
						}

						if (i == 0) {
							if (that.historyList.length == 0) {
								if (that.showpage == '2') {
									scrollid = "historynew-0";
								} else {
									scrollid = "history-0";
								}
							} else {
								scrollid = "history-" + list[i].id;
							}
						}
						that.historyList.unshift(list[i]);
					}
				}
				if (scrollid != '') {
					setTimeout(function() {
						that.scrollid = scrollid;
						console.log(that.scrollid)
						that.setpostion(scrollid)
						//	that.setpostion("history-0")
					}, 200)
				}

				console.log(that.historyList)

				if (!that.isIos()) {
					that.addListener("markdown01")
				}

			})

		}


		//监听图片长按事件
		addListener(id) {
			let _this = this;
			_this.$nextTick(() => {
				let markDom = document.getElementById(id);
				// 添加事件监听器
				if (markDom) {
					// 添加事件监听器
					markDom.removeEventListener('mousedown', _this.start);
					markDom.removeEventListener('touchstart', _this.start);

					// 取消计时器
					markDom.removeEventListener('click', _this.cancel);
					markDom.removeEventListener('mouseout', _this.cancel);
					markDom.removeEventListener('touchend', _this.cancel);


					markDom.addEventListener('mousedown', _this.start);
					markDom.addEventListener('touchstart', _this.start);
					markDom.addEventListener('touchend', _this.cancel);
					markDom.addEventListener('touchmove', _this.move);

					// 取消计时器
					markDom.addEventListener('click', _this.cancel);
					markDom.addEventListener('mouseout', _this.cancel);
				}
			})
		}

		start(e) {
			let _this = this;
			//不是图片不触发
			if (!e || !e.target || _this.showDownloadImgPopup == true || e.target.tagName.toLowerCase() != 'img') {
				return
			}
			_this.moveY = 0;
			_this.startY = e.touches[0].clientY;

			if (_this.pressTimer === null) {
				console.log(1)
				_this.pressTimer = setTimeout(() => {

					// let posX = 0, posY = 0;
					// if (e.pageX || e.pageY) {
					// 	posX = e.pageX;
					// 	posY = e.pageY;
					// } else if (e.touches && e.touches[0] && (e.touches[0].pageX || e.touches[0].pageY)) {
					// 	posX = e.touches[0].pageX;
					// 	posY = e.touches[0].pageY;
					// }

					// 执行函数
					console.log(2)
					console.log(e, '执行复制图片')
					// document.getElementById('imagePopup').style.left = posX + 'px';
					// document.getElementById('imagePopup').style.top = posY + 'px';
					if ((_this.moveY < 50 && _this.moveY >= 0) || (_this.moveY > -50 && _this.moveY < 0)) {
						_this.downLoadImgUrl = e.target.src;
						_this.showDownloadImgPopup = true;
						navigator.vibrate(100);
					}

				}, 1000);
			}
		}
		move(e) {
			let _this = this;
			if (e && e.touches) {
				_this.moveY = (e.touches[0].clientY - _this.startY) as any;
			}
		}
		cancel(e) {
			let _this = this;
			if (_this.pressTimer !== null) {
				clearTimeout(_this.pressTimer);
				_this.pressTimer = null;
			}
		}

		downloadImg() {
			if (this.downLoadImgUrl) {
				//window.open(this.downLoadImgUrl);
				var that = this;
				(window as any).gis.saveImageToAlbum(that.downLoadImgUrl, function(res) {
					if (res) {
						that.$Message.success(that.L('保存成功'));
					} else {
						that.$Message.warning(that.L('保存失败'));
					}
				});
			}
			//数据还原
			this.reset();
		}
		reset() {
			this.cancel();
			this.showDownloadImgPopup = false;
		}

		setpostion(scrollid) {
			this.$nextTick(() => {
				const el = document.getElementById(scrollid);
				if (el) {
					// el.scrollIntoView({ behavior: 'smooth' });
					el.scrollIntoView(false);
					//el.scrollIntoView({ behavior: 'smooth' });
				}
			});
		}
		dianzan() {
			var that = this;
			var sid = (that.sessinfo as any).id;
			this.$store.dispatch({
				type: 'app/setSessionLike',
				data: {
					id: sid
				}
			}).then((res) => {
				if (that.actiontype == 0) {
					that.actiontype = 1;
				} else {
					that.actiontype = 0;
				}


			})
		}
		diancai() {
			var that = this;
			var sid = (that.sessinfo as any).id;
			this.$store.dispatch({
				type: 'app/setSessionStomp',
				data: {
					id: sid
				}
			}).then((res) => {
				if (that.actiontype == 0) {
					that.actiontype = 2;
				} else {
					that.actiontype = 0;
				}
			})
		}
		goStop() {
			var that = this;
			this.answerstop = true;
			this.disabled = false;
			this.showstop = true;
			console.log('stop');
		}

		againSend() {
			var that = this;
			that.historyList = [];
			that.loadingType = 0;
			that.scrollid = "";
			that.pageindex = 1;
			that.showpage = '1';
			that.sessionid = "";
			that.historyNew = [];
			that.showHistory = true;
			that.showTool = false;
			that.showmenu = false;
		}

		onScroll(event) {
			this.showmenu = false;

		}

		//获取到焦点 （解决键盘遮挡input问题）
		inputOnFocus() {
			setTimeout(() => {
				document.body.scrollTop = document.body.scrollHeight
			}, 300)
		}

		//input失焦聚焦
		handleClick(e) {
			let _this = this;
			try {
				e.preventDefault();
				_this.$refs.input.blur();
				_this.$refs.input.focus();
				this.$nextTick(() => {
					_this.$refs.input.blur();
					_this.$refs.input.focus();
				});
			} catch (ex) {
				//TODO handle the exception
			}
		}


		sessionSave() {
			var that = this;
			if (that.prompt.length == 0) {
				return;
			}
			var hour = (new Date()).getHours().toString();
			if (parseInt(hour) < 10) {
				hour = "0" + hour;
			}
			var mins = (new Date()).getMinutes().toString();
			if (parseInt(mins) < 10) {
				mins = "0" + mins;
			}
			var time = hour + ":" + mins;
			var showdate = false;
			if (that.historyNew.length == 0) {
				showdate = true
			}
			var info = {
				id: 0,
				prompt: that.prompt,
				answer: '',
				isload: true,
				showdate: showdate,
				datetime: time,
				voice: that.keyboardvic
			}

			var scrollid = "prompt-" + info.id;
			// setTimeout(function() {
			// 	that.scrollid = scrollid;
			// 	that.setpostion("history-0")
			// }, 200)

			that.historyNew.push(info);
			that.prompt = '';
			that.isSend = false;
			that.disabled = true;
			that.sessinfo = info;
			that.actiontype = 0;
			var scrollidhis = "";
			if (that.showpage == '2') {
				scrollidhis = "historynew-0";
			} else {
				scrollidhis = "history-0";
			}
			that.setpostion(scrollidhis)

			var para = {
				prompt: info.prompt,
				appId: that.appid,
				sessionId: that.sessionid,
				userId: that.userid
			}

			var basepro = Base64.encode(info.prompt.trim()).replaceAll("+", "%2B");
			// setTimeout(function () {
			// 	that.disabled = false
			// }, 2000)
			// return

			//var bas = Base64.encode(JSON.stringify(para)) ;		

			// console.log(liburl + "/api/SessionAI/SessionCompletion?prompt=" + basepro + "&appId=" +
			// 	that.appid + "&sessionId=" + that.sessionid + "&userId=" + that.userid)
			// return;

			// if (that.passuserid.indexOf(that.userid) == -1) {
			// 	setTimeout(function() {
			// 		var v = Math.round(Math.random() * 1000);
			// 		var history = that.historyNew[that.historyNew.length - 1];
			// 		(history as any).isload = false;
			// 		(history as any).id = v;
			// 		(that.sessinfo as any).id = v;
			// 		that.showTool = false;
			// 		that.showstop = false;
			// 		(history as any).answer = "当前CURI用户过多，请您稍后再试。";
			// 		that.ansterdata = "当前CURI用户过多，请您稍后再试。";
			// 		that.disabled = false;
			// 		return
			// 	}, 1000)

			// 	return
			// }
			// console.log("pass")
			// return

			var source = new EventSource(liburl + "/api/SessionAI/SessionCompletion?prompt=" + basepro + "&appId=" +
				that.appid + "&sessionId=" + that.sessionid + "&userId=" + that.userid);
			//var source = new EventSource(liburl + "/api/SessionAI/SessionCompletion?params=" + bas )
			source.onopen = function(event) {
				console.log("建立连接..." + "<br/>")
				that.answerstop = false;

				//$("#result").prepend("建立鏈接..." + "<br/>")
			};
			source.onmessage = function(event) {
				//console.log(event.data)
				if (event.data.indexOf('end-') > -1) {
					that.disabled = false;
					console.log(event.data);

					var history = that.historyNew[that.historyNew.length - 1];
					var rid = event.data.replace('end-', '');
					var ridarr = rid.split('-');
					if (ridarr.length > 0) {
						rid = ridarr[0];
					}
					if (ridarr.length > 1) {
						if (that.sessionCount >= 5) {
							that.sessionCount = 0;
							that.sessionid = "";
						} else {
							that.sessionid = ridarr[1];
							that.sessionCount++;
						}

					}
					(history as any).isload = false;
					(history as any).id = rid;
					(that.sessinfo as any).id = rid;
					that.showTool = true;
					that.showstop = false;

					if (!that.isIos()) {
						that.addListener("markdown02")
					}


					//回答完成页面滑动到底部
					that.$nextTick(() => {
						try {
							let dom1 = document.getElementsByClassName("weui-pull-present-box")[0];
							if (dom1 && dom1.scrollHeight != dom1.clientHeight) {
								dom1.scrollTop = dom1.scrollHeight - dom1.clientHeight;
							}
						} catch (e) {
							//TODO handle the exception
						}
					})
					//that.$Message.success(event.data)

				} else {
					if (!that.answerstop) {
						var history = that.historyNew[that.historyNew.length - 1];


						var answer = (history as any).answer;
						try {
							var rsp = JSON.parse(event.data).response;
							if (rsp != '') {
								(history as any).isload = false;
								(history as any).answer = rsp;
								that.ansterdata = rsp;
							}

						} catch (e) {
							//TODO handle the exception
							var contans = he.decode(event.data);
							if (contans != '') {
								(history as any).isload = false;
								(history as any).answer = he.decode(event.data);
								that.ansterdata = event.data;
							}

						}
					}


					//(history as any).answer+=event.data


					// var response=JSON.parse(event.data).response.replace(answer,'');
					// var response=event.data.replace(answer,'');
					// var i=0;
					//  var showChar = function() {
					//         if (i < response.length) {
					//             (that.historyNew[that.historyNew.length - 1] as any).answer += response[i++]; // 添加字符并递增索引
					//             setTimeout(showChar, 100); // 每100毫秒显示下一个字符
					//         }
					//     };




					//(history as any).answer = JSON.parse(event.data).response;
				}

				//$("#result").prepend(event.data + "<br/>")
			};
			source.onerror = function(event) {
				console.log("关闭连接..." + "<br/>")
				that.answerstop = true;
				var history = that.historyNew[that.historyNew.length - 1];
				(history as any).isload = false;
				if ((history as any).answer == '') {
					(history as any).answer = that.L("请稍后再试");
					(history as any).id = -1;
				}
				that.showstop = false;
				that.disabled = false;
				//$("#result").prepend("關閉鏈接..." + "<br/>")
				source.close();
			}
		}
		setImgAuth() {
			var that = this;
			var u = navigator.userAgent.toLowerCase();


			//统一使用组件方式查看图片可以缩放
			if (1 == 1 || u.indexOf('iphone os 13_4') > -1 || u.indexOf('iphone os 14') > -1 || u.indexOf(
					'ipad') > -1 || u.indexOf('ipod') > -1 || that.screenWidth >= 768) {
				let imgs = document.getElementsByClassName('newscot')[0].getElementsByTagName('img');
				for (var i = 0; i < imgs.length; i++) {
					var img = imgs[i] as any;
					img.onclick = function(e) {
						// that.currentImgUrl = e.currentTarget.src;
						// that.currentImgs = [];
						// that.currentImgs.push(that.currentImgUrl);
						// that.imgBox = true;
						// that.$forceUpdate();
						//(window as any).gis.previewImage([e.currentTarget.src]);
						that.currentImgUrl = e.currentTarget.src;
						that.currentImgs = [];
						that.currentImgs.push(that.currentImgUrl);
						//that.imgBox = true;
						const ViewerDom = document.getElementById('viewer');
						((ViewerDom as any).viewer as any).options.title = false;
						((ViewerDom as any).viewer as any).options.navbar = false;
						((ViewerDom as any).viewer as any).options.toolbar = false;
						((ViewerDom as any).viewer as any).images = that.currentImgs;
						setTimeout(function() {
							var contain = document.getElementsByClassName('descimgBox')[0]
								.getElementsByTagName('img');;
							if (contain != null && contain.length > 0) {
								contain[0].click();
							}
						}, 300)
					}
					// img.ontouchend = function(e) {
					// 	(window as any).gis.previewImage([e.currentTarget.src]);
					// }
				}
			} else {
				let imgs = document.getElementsByClassName('newscot')[0].getElementsByTagName('img');

				for (var i = 0; i < imgs.length; i++) {
					var img = imgs[i] as any;
					img.onclick = function(e) {
						var img = imgs[i] as any;
						img.onclick = function(e) {
							(window as any).gis.previewImage([e.currentTarget.src]);
						}
					}

				}
			}

		}


		getAIListAll() {
			var that = this;
			var request = new Object() as any;
			request.maxResultCount = 100;
			request.skipCount = 1;

			this.$store.dispatch({
				type: 'app/getAIListAll',
				data: request
			}).then((res) => {

				var result = res.items;
				that.appList = result;
				if (result.length > 0) {
					that.appid = result[0].id;
					that.tabTitle = "chat";
					console.log(that.appid);
					that.getSessionNew();
				}

			})
		}
		getLoginUser() {
			var that = this;
			this.$store.dispatch({
				type: 'app/getLoginUser',
				data: {}
			}).then(res => {
				that.userid = res.id;
				that.userInfo = res;
			})
		}
		formatDateStr(dateString) {
			var that = this;
			if (dateString != null && dateString.length > 0) {
				dateString = dateString.substr(0, 19);
				dateString = dateString.replace(/-/g, "/").replace(/T/g, " ");

				var datetime = new Date(dateString);
				var dateTimeStamp = datetime.getTime();

				var minute = 1000 * 60; //把分，时，天，周，半个月，一个月用毫秒表示
				var hour = minute * 60;
				var day = hour * 24;
				var week = day * 7;
				var halfamonth = day * 15;
				var month = day * 30;
				var now = new Date().getTime(); //获取当前时间毫秒
				var diffValue = now - dateTimeStamp; //时间差

				if (diffValue < 0) {
					console.log("diffValue<0", datetime, dateTimeStamp, now, diffValue);
					return that.L('刚刚');
				}
				var minC = diffValue / minute; //计算时间差的分，时，天，周，月
				var hourC = diffValue / hour;
				var dayC = diffValue / day;
				var weekC = diffValue / week;
				var monthC = diffValue / month;
				var result = "";
				if (datetime.getFullYear() == new Date().getFullYear() && monthC >= 1 && monthC <= 12) {
					//result = " " + parseInt(monthC) + "月前"
					result = this.formatDate(datetime, 'MM-dd hh:mm')
				} else if (weekC >= 1 && weekC <= 4) {
					//result = " " + parseInt(weekC) + "周前"
					result = this.formatDate(datetime, 'MM-dd hh:mm')
				} else if (dayC >= 1 && dayC <= 7) {
					if (datetime.getDate() == new Date().getDate() - 1) {
						result = that.L('昨天') + ' ' + this.formatDate(datetime, 'hh:mm')
					} else if (datetime.getDate() == new Date().getDate() - 2) {
						//result = "前天 " + this.formatDate(datetime, 'hh:mm')
						result = this.formatDate(datetime, 'MM-dd hh:mm')
					} else {
						//result = " " + parseInt(dayC) + "天前"
						result = this.formatDate(datetime, 'MM-dd hh:mm')
					}

				} else if (hourC >= 1 && hourC <= 24) {
					if (datetime.getDate() == new Date().getDate()) {
						result = that.L('今天') + ' ' + this.formatDate(datetime, 'hh:mm')
					} else {
						result = that.L('昨天') + ' ' + this.formatDate(datetime, 'hh:mm')
					}
					//result = " " + parseInt(hourC) + "小时前"
				} else if (minC >= 1 && minC <= 59) {
					result = " " + minC.toFixed(0) + that.L('分钟前')
				} else if (diffValue >= 0 && diffValue <= minute) {
					result = that.L('刚刚');
				} else {
					var datetime = new Date();
					datetime.setTime(dateTimeStamp);
					var Nyear = datetime.getFullYear(); {}
					var Nmonth = datetime.getMonth() + 1 < 10 ? "0" + (datetime.getMonth() + 1) : datetime.getMonth() +
						1;
					var Ndate = datetime.getDate() < 10 ? "0" + datetime.getDate() : datetime.getDate();
					var Nhour = datetime.getHours() < 10 ? "0" + datetime.getHours() : datetime.getHours();
					var Nminute = datetime.getMinutes() < 10 ? "0" + datetime.getMinutes() : datetime.getMinutes();
					var Nsecond = datetime.getSeconds() < 10 ? "0" + datetime.getSeconds() : datetime.getSeconds();
					result = Nyear + "-" + Nmonth + "-" + Ndate
				}
				return result;

			}
		}
		formatDate(date, fmt) {
			if (date != null) {
				if (/(y+)/.test(fmt)) {
					fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
				}
				// // #ifdef APP-PLUS  
				// date.setHours(date.getHours()-8);
				// // #endif 
				let o = {
					'M+': date.getMonth() + 1,
					'd+': date.getDate(),
					'h+': date.getHours(),
					'm+': date.getMinutes(),
					's+': date.getSeconds()
				};
				for (let k in o) {
					if (new RegExp(`(${k})`).test(fmt)) {
						let str = o[k] + '';
						fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : this.padLeftZero(str));
					}
				}
				return fmt;
			} else {
				return '';
			}

		}
		padLeftZero(str) {
			return ('00' + str).substr(str.length);
		}
		getSessionInfo() {
			var that = this;
			var that = this;
			var request = new Object() as any;
			request.maxResultCount = this.pagesize;
			request.skipCount = (this.pageindex - 1) * this.pagesize;
			request.id = that.sid
			request.onlyMy = false;
			this.$store.dispatch({
				type: 'app/getSessionHistoryList',
				data: request
			}).then((res) => {
				var list = res.items;
				that.showpage = '1'
				if (list.length > 0) {
					that.historyList.push(list[0]);
				}
			})
		}
		getSessionNew() {
			var that = this;
			this.$store.dispatch({
				type: 'app/getSessionHistoryNewByUser',
				id: that.appid
			}).then((res) => {
				if (res && res.prompt) {
					that.lastTitle = res.prompt;
				}
			})
		}


		@Watch('ansterdata')
		ansterdataChange(newItems) {
			var that = this;
			var scrollidhis = "";
			if (that.showpage == '2') {
				scrollidhis = "historynew-0";
			} else {
				scrollidhis = "history-0";
			}
			that.setpostion(scrollidhis)
			//that.setpostion("history-0")

			// 监听数据变化，当数据增加时自动滚动
			// this.$nextTick(() => {		     
			//     let chat = this.$refs.history0;
			//       chat.scrollTop = chat.scrollHeight
			// });
		}





		@Watch('$route')
		routechange(to: any, from: any) {
			if (to.query.sid != from.query.sid) {
				location.reload();
			}
			if (to.query.t != from.query.t) {
				this.pageLoad();
			}
		}


		handleResize() {
			var elementHeight = window.innerHeight;
			this.scrollHeight = elementHeight - 130;
			//console.log('元素高度:', window.innerHeight);
			//this.setpostion("history-0")
		}

		async pageLoad() {
			console.log("pageLoad")
			var that = this;
			that.title = that.L("开启了新话题，下拉回顾")
			that.audioTitle = that.L("按住说话");
			that.sendTitle = that.L("松开发送，上滑取消");
			that.pcAudioTitle = that.L("点击开始录音");
			that.pcSendTitle = that.L("点击停止录音");
			that.screenWidth = document.body.clientWidth
			window.document.title = that.L("AI对话");
			//window.document.title="<div style='color:red'>AI对话</div>";
			that.isios = that.isIos();

			that.historyList = [];
			that.loadingType = 0;
			that.scrollid = "";
			that.pageindex = 1;
			that.sessionid = "";
			that.historyNew = [];
			that.lastTitle = "";
			that.showpage = '2';
			that.downLoadImgUrl = "";
			that.showDownloadImgPopup = false;
			that.showTool = false;


			window.addEventListener('resize', this.handleResize);

			var data = moment().format('M月DD日');
			const hour = (new Date()).getHours();
			if (hour >= 0 && hour < 12) {
				that.noonTip = that.L('上午好')
			} else if (hour >= 12 && hour < 18) {
				that.noonTip = that.L('下午好')
			} else {
				that.noonTip = that.L('晚上好')
			}

			var time = '周' + '日一二三四五六'.charAt(new Date().getDay())

			console.log("lan:" + abp.localization.currentCulture.name)
			that.lang = abp.localization.currentCulture.name

			if (that.lang == "en") {
				var month = (new Date()).getMonth() + 1;
				that.dateToday = that.L(month + "月") + (new Date()).getDate() + 'th';
			} else {
				that.dateToday = moment().format('M月DD日');
			}
			that.weekToday = that.L(time);
			console.log(data + "，" + that.weekToday)


			//localStorage.setItem("AcTitle","AI对话")

			var u = navigator.userAgent.toLowerCase();
			//console.log(navigator.userAgent)
			if (u.indexOf('iphone') > -1 || u.indexOf('ipad') > -1 || u.indexOf('ipod') > -1 || u.indexOf('android ') >
				-1) {
				console.log('当前在手机端');
				that.ispc = false
			} else {
				console.log('当前在PC端');
				that.ispc = true;
				that.title = that.L("点击回顾历史");
			}

			that.sessionCount = 0;
			that.sessionid = "";
			that.historyNew = [];



			console.log(Util.abp.session.userId)
			if (Util.abp.session.userId) {
				this.userid = Util.abp.session.userId;
				this.getLoginUser();
				this.getTipsList();
			}
			if (!Util.abp.session.userId) {
				var domain = this.$route.query.domain as any;

				if (domain != undefined && domain != null && domain != '') {
					await this.$store.dispatch({
						type: 'app/externalAuthenticate',
						data: {
							"AuthProvider": "IDSDOMAIN",
							"ProviderAccessCode": domain,
							ProviderKey: "",
							Property: ""
						},
					})
					location.reload();
				}
				var userId = this.$route.query.userid as any;
				if (userId != undefined && userId != null && userId != '') {
					//if (that.passuserid.indexOf(userId * 1) > -1) {
					if (userId != Util.abp.session.userId) {
						await this.$store.dispatch({
							type: 'app/externalAuthenticate',
							data: {
								"AuthProvider": "IDSID",
								"ProviderAccessCode": userId,
								ProviderKey: userId,
								Property: ""
							},
						})
						console.log(Util.abp.session.userId)
						location.reload();
					}
					//}

				}
				//var code = this.getQueryVariable("id_token");
				var code = this.$route.query.id_token as any;
				if (code != undefined && code != null && code != '') {
					var res = await this.$store.dispatch({
						type: 'app/applicationAuthenticate',
						data: {
							appId: 'q0ropkfajb9zk78d',
							appSecret: 'tao4dd03fwq7h8whdpoarfw1knpw44gu'
						},
					})
					if (res && res.accessToken) {
						var res2 = await this.$store.dispatch({
							type: 'app/getUserInfo',
							data: code
						})
						if (res2 && res2.mobile) {
							var res3 = await this.$store.dispatch({
								type: 'app/getUserByUserName',
								data: res2.mobile
							})
							await this.$store.dispatch({
								type: 'app/externalAuthenticate',
								data: {
									"AuthProvider": "IDSID",
									"ProviderAccessCode": res3.id,
									ProviderKey: res3.id,
									Property: ""
								},
							})
							//that.pageLoad();
							location.reload();
						}

					}


					// var res = await this.$store.dispatch({
					// 	type: 'app/externalAuthenticate',
					// 	data: {
					// 		"AuthProvider": "IDS",
					// 		"ProviderAccessCode": code,
					// 		ProviderKey: "",
					// 		Property: ""
					// 	}
					// })
					// location.reload();
				}
			} else {
				var userId = this.$route.query.userid as any;
				if (userId != undefined && userId != null && userId != '') {
					//if (that.passuserid.indexOf(userId * 1) > -1) {
					if (userId != Util.abp.session.userId) {
						await this.$store.dispatch({
							type: 'app/externalAuthenticate',
							data: {
								"AuthProvider": "IDSID",
								"ProviderAccessCode": userId,
								ProviderKey: userId,
								Property: ""
							},
						})
						location.reload();
					}
					//}


				}
			}



			if (this.$route.query.sid && (this.$route.query.sid as any) > 0) {
				this.sid = this.$route.query.sid as any;

				if (Util.abp.session.userId) {
					this.userid = Util.abp.session.userId;
					this.getLoginUser();


				}
				this.getSessionInfo();
			}
			if (this.userid > 0) {
				this.getAIListAll();
				if (Util.abp.auth.grantedPermissions.AppAIUser != undefined && Util.abp.auth.grantedPermissions
					.AppAIUser
					.toLowerCase() == 'true') {
					this.showai = true;
				} else {
					this.showai = false;
				}
				if (Util.abp.auth.grantedPermissions.AIManger != undefined && Util.abp.auth.grantedPermissions.AIManger
					.toLowerCase() == 'true') {
					this.showzhushou = true;
				} else {
					this.showzhushou = false;
				}
			} else {
				this.isRefresh = false;
				that.title = ""
			}



		}

		async created() {
			var that = this;
			that.pageLoad();
		}
		// unmounted() {
		// 	window.removeEventListener("resize", () => {
		// 		document.activeElement.scrollIntoView(true);
		// 	});
		// }
		mounted() {
			var that = this;
			// this.$nextTick(() => {
			// 	window.addEventListener("resize", () => {
			// 		document.activeElement.scrollIntoView(true);
			// 	});
			// })


			this.$nextTick(() => {
				this.$refs.gethistoryheight
			})

			this.$nextTick(() => {
				let elementHeight = (this.$refs.aibox as any).offsetHeight;
				that.scrollHeight = elementHeight - 130;
				console.log('元素高度:', elementHeight);
			});


			//循环滚动定时器
			this.$nextTick(() => {
				clearInterval(that.transTimer);
				that.transTimer = Number(setInterval(() => {
					if (that.currentIndex + 1 < that.tagList.length) {
						that.transition = 300
						that.currentIndex = that.currentIndex + 1
					} else {
						that.transition = 0
						that.currentIndex = 0
					}
				}, 3000));
			})
		}

		$destroy() {
			clearInterval(this.transTimer);
		}


	};
